import { render, staticRenderFns } from "./CorrectInvalidData.vue?vue&type=template&id=c945ae6e&"
import script from "./CorrectInvalidData.vue?vue&type=script&lang=js&"
export * from "./CorrectInvalidData.vue?vue&type=script&lang=js&"
import style0 from "./CorrectInvalidData.vue?vue&type=style&index=0&id=c945ae6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports